import {Directive, ElementRef, EventEmitter, HostBinding, HostListener, Output} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {GoogleDialogComponent} from '../components/GoogleDialog/GoogleDialog.component';
import {MatDialog} from '@angular/material/dialog';


@Directive({
    selector: '[appUploadImage]'
})

export class UploadImageDirective {
    hostElementRect: DOMRect | undefined = undefined;
    @Output() dropFile = new EventEmitter<{ file: File, url: SafeUrl }>();
    @Output() dragOverEvent  = new EventEmitter<any>();
    @Output() dragLeaveEvent  = new EventEmitter<any>();

    @HostBinding('style.background-color') hostBackgroundColor!: string;

    @HostListener('dragover', ['$event']) dragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.dragOverEvent.emit();

        this.hostBackgroundColor = DropColor.DURING_DROP;
    }

    @HostListener('dragleave', ['$event']) dragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();

        this.hostElementRect = this.hostElement.nativeElement.getBoundingClientRect();

        if (event.clientX < this.hostElementRect!.left ||
            event.clientX > this.hostElementRect!.right ||
            event.clientY < this.hostElementRect!.top ||
            event.clientY > this.hostElementRect!.bottom) {

            this.dragLeaveEvent.emit();
            this.hostBackgroundColor = DropColor.BEFORE_DROP;
        }

    }

    @HostListener('drop', ['$event']) drop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.hostBackgroundColor = DropColor.AFTER_DROP;

        const fileList = event.dataTransfer?.files;
        if (fileList === undefined) {
            return;
        }

        const file = fileList[0];
        const fileExtension = this.getFileExtension(file.name);
        if (fileExtension && !['png', 'jpg', 'jpeg'].includes(fileExtension.toLowerCase())) {
            this.droppedUnSupportedImageType();
            this.dragLeaveEvent.emit();
            return;
        } else {
            const url = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(file));
            this.dropFile.emit({file, url});
        }
    }

    constructor(private hostElement: ElementRef, private sanitizer: DomSanitizer,
                private dialog: MatDialog) {}

    getFileExtension(filename: string): string | undefined  {
        const parts = filename.split('.');
        if (parts.length > 1) {
            return parts.pop();
        }
        return undefined;
    }

    droppedUnSupportedImageType() {
        const errorDialog = this.dialog.open(GoogleDialogComponent, {
            data: {
                closable: true,
                dialogType: true,
                libConfirmBtn: 'OK',
                title: 'Attention',
                msg: 'Seules les images PNG, JPG et JPEG sont prises en charge !',
            },
        });
    }
}

enum DropColor {
    BEFORE_DROP = '#80808017',
    DURING_DROP = '#8080807d',
    AFTER_DROP = '#80808017'
}
